.root {
  display: flex;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 6px;
  color: var(--on-background);
  cursor: default;
  background: transparent;
  border-radius: 4px;

  button {
    padding: 0;
  }

  .text {
    line-height: 1;
    letter-spacing: 1px;
    transform: translateY(1px);
  }
}
